/**********************
 *
 * This component is called via the Credit Card  processor when the
 * decides to cancel/payment for the service.
 */

import React from "react";
import { useParams } from "react-router-dom";

export default (props) => {
  let { dateValue } = useParams();

  if (dateValue) {
    window.location.href = "/survey?dateValue=" + dateValue;
  } else
    return (
      <div
        style={{
          marginTop: "5px",
          color: "black",
          margin: "auto auto",
          padding: "0 1em 1em",
          width: "70%",
          fontSize: "1.5em",
        }}
      >
        <h2>Cancelled Invoice ID:{dateValue}</h2>
        <p>Perhaps we'll see you in the future!</p>
        <a href="http://www.complexhealthsolutions.com/">Back to site</a>
      </div>
    );
};
